export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    structure: 'Structure',
    contact: 'Contact'
  },
  footer: {
    legal: 'Legal',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    cookieSettings: 'Cookie-Einstellungen',
    contact: 'Kontakt',
    copyright: '© 2026 DR Group GmbH. Alle Rechte vorbehalten.',
    registerCourt: 'Registergericht',
    hrb: 'HRB',
    vatId: 'USt-IdNr.'
  },
  contact: {
    email: 'E-Mail',
    address: 'Postanschrift',
    phone: 'Telefon'
  },
  cookies: {
    title: 'Cookie-Einstellungen',
    description: 'Wir verwenden notwendige Cookies für den sicheren Betrieb der Website. Optionale Cookies setzen wir nur mit Ihrer Einwilligung. Details finden Sie unter Cookie-Einstellungen und in der Datenschutzerklärung.',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alles ablehnen',
    settings: 'Einstellungen',
    settingsTitle: 'Cookie-Einstellungen',
    settingsIntro: 'Hier können Sie Ihre Cookie-Präferenzen verwalten. Notwendige Cookies sind immer aktiv, da sie für den Betrieb der Website erforderlich sind.',
    necessary: 'Notwendige Cookies',
    necessaryDesc: 'Diese Cookies sind für den sicheren Betrieb der Website erforderlich und können nicht deaktiviert werden.',
    functional: 'Funktionale Cookies',
    functionalDesc: 'Diese Cookies ermöglichen erweiterte Funktionen und Personalisierung.',
    analytics: 'Analyse-Cookies',
    analyticsDesc: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren.',
    marketing: 'Marketing-Cookies',
    marketingDesc: 'Diese Cookies werden verwendet, um Besuchern relevante Werbung anzuzeigen.'
  }
};